import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import * as queryString from 'query-string'
dayjs.extend(utc)
dayjs.extend(timezone)

export const fromLocalToUtcFormatDate = (date: string, format: string) => {
  if (!date) {
    return ''
  }
  return dayjs(date).utc().format(format)
}

export const fromUtcToLocalFormatDate = (date: string, format: string) => {
  if (!date) {
    return ''
  }
  return dayjs.utc(date).tz().format(format)
}

export const fetchPageNumberV2 = (location): number => {
  const { page = '1' } = queryString.parse(location.search)
  return Number(page)
}

export const isAddOrEditRouteV2 = (path: string): boolean => {
  return /.*\/(add|:id\/edit)$/.test(path)
}

export const createTitle = (title) => {
  return `${title} - LeadGrid`
}

export function deepAssign(...args) {
  let name, options, src, copy
  const length = args.length
  let i = 1
  let target = args[0] || {}
  if (typeof target !== 'object') {
    target = {}
  }
  for (; i < length; i++) {
    options = args[i]
    if (options != null) {
      for (name in options) {
        src = target[name]
        copy = options[name]
        if (copy && typeof copy == 'object') {
          //@ts-ignore
          target[name] = deepAssign(src, copy)
        } else if (copy !== undefined) {
          target[name] = copy
        }
      }
    }
  }

  return target
}

export const removeLeadgridCmsClasses = (classNames: string) => {
  return classNames
    .split(' ')
    .filter((className) => !className.includes('leadgridCms'))
    .join(' ')
}

export const isArrayDiff = (array1: any[], array2: any[]) => {
  return (
    array1.length !== array2.length ||
    array1.some((value, index) => value !== array2[index])
  )
}

export const containWhitespace = (value: string) => {
  return /\s/.test(value)
}
